var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper d-flex justify-content-center align-items-center",style:(_vm.wrapperStyle)},[_c(_vm.loaderComponent,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }